














































import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Helpers
 */
import { iconFaction } from "@/config/image-links";

/**
 * Utils
 */

/**
 * Mixins
 */

/**
 * Components
 */

/**
 * API
 */

/**
 * Types
 */

/**
 * VueX Modules
 */


@Component
export default class TeamCard extends Vue {
	/// Injections
	iconFaction = iconFaction;

	/** Props */
	@Prop()
	id!: string;
	@Prop()
	name!: string;
	@Prop()
	realm!: string;
	@Prop()
	side!: string | null;
	@Prop()
	nbRegisteredCharacters!: number | null;
	@Prop()
	nbRosters!: number | null;

	@Prop()
	buttonText!: string;
	@Prop()
	buttonColor!: string;

	@Prop()
	link!: string;

	@Prop()
	isLoading!: boolean;

	/// Methods
	handleClick() {
		this.$emit("click", this.id);
	}

	handleOpenLeaveTeamClick() {
		this.$emit("onOpenLeaveTeamClick");
	}
}
